export class GetHistoryDataArgs {
    /**
     * 获取历史数据参数
     * @param dataSourceCode 数据源编码
     * @param dataItemName 历史数据条目名称
     * @param channelNames 通道名称
     * @param startTime 开始时间
     * @param endTime 结束时间
     * @param limit 获取数据数量，为负数则倒叙
     * @param rangeType 区间类型
     */
    constructor(dataSourceCode, dataItemName, channelNames, startTime, endTime, limit, rangeType) {
        this.dataSourceCode = dataSourceCode;
        this.dataItemName = dataItemName;
        this.channelNames = channelNames;
        this.startTime = startTime;
        this.endTime = endTime;
        this.limit = limit;
        this.rangeType = rangeType;
    }
}
